import Button from '__core/modules/atoms/Button';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const FooterButtons = ({
  buttonTextCancel = 'Cancel',
  buttonTextSucess = 'Confirm',
  buttonTextSucessColor,
  disabledCancel,
  disabledSuccess = false,
  focusableWhenDisabled = false,
  isCustomFooterLeft = false,
  loadingCancel,
  loadingSuccess,
  onBackFooter,
  onCancel,
  onSuccess = () => {},
  t,
}) => {
  return (
    <div
      className={clsx('d-flex justify-content-between', {
        'w-100': isCustomFooterLeft,
        'w-50': !isCustomFooterLeft,
      })}
    >
      <div>{onBackFooter && <Button color="transparent" type="reset" variant="inline" onClick={onBackFooter} text={t('actions:Back')} size="small" />}</div>

      <div className="footer-buttons">
        {onCancel && (
          <Button
            color="transparent"
            disabled={disabledCancel}
            focusableWhenDisabled={focusableWhenDisabled}
            loading={loadingCancel}
            onClick={onCancel}
            size="small"
            text={buttonTextCancel}
            type="reset"
            variant="inline"
          />
        )}

        {onSuccess && (
          <Button
            color={buttonTextSucessColor}
            disabled={disabledSuccess}
            focusableWhenDisabled={focusableWhenDisabled}
            loading={loadingSuccess}
            onClick={onSuccess}
            size="small"
            text={buttonTextSucess}
            type="submit"
            variant="inline"
          />
        )}
      </div>
    </div>
  );
};

FooterButtons.propTypes = {
  buttonTextCancel: PropTypes.string,
  buttonTextSucess: PropTypes.string,
  buttonTextSucessColor: PropTypes.string,
  disabledCancel: PropTypes.bool,
  disabledSuccess: PropTypes.bool,
  focusableWhenDisabled: PropTypes.bool,
  loadingCancel: PropTypes.bool,
  loadingSuccess: PropTypes.bool,
  isCustomFooterLeft: PropTypes.bool,
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func,
};

export default FooterButtons;
